var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-component",class:_vm.prefixCls,on:{"click":function($event){return _vm.$router.push({name:'helpCenter'})}}},[_c('a-icon',{staticStyle:{"font-size":"20px","cursor":"pointer","display":"inline-block"},attrs:{"type":"question-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }